(() => {
  'use strict';
  const initialized = new WeakSet();
  let active = null;
  let scrollState = null;
  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
  function restoreScroll() {
    if (!scrollState) return;
    document.documentElement.style.overflow = scrollState.html;
    document.body.style.overflow = scrollState.body;
    document.body.style.paddingRight = scrollState.padding;
    scrollState = null;
  }
  function closePanel(panel) {
    if (typeof panel.close === 'function') panel.close();
    else { panel.removeAttribute('open'); panel.dispatchEvent(new Event('close')); }
  }
  function initPanel(panel) {
    if (initialized.has(panel)) return;
    initialized.add(panel);
    let opener = null;
    let backdropDown = false;
    let loadingTimer;
    panel.addEventListener('close', () => {
      clearTimeout(loadingTimer);
      if (active === panel) { active = null; restoreScroll(); }
      document.querySelectorAll('[data-nfc-reviews-open]').forEach(button => {
        if (button.dataset.nfcReviewsOpen === panel.id) button.setAttribute('aria-expanded', 'false');
      });
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
    panel.querySelector('[data-nfc-reviews-close]')?.addEventListener('click', () => closePanel(panel));
    const outside = event => {
      const rect = panel.getBoundingClientRect();
      return event.target === panel && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    };
    panel.addEventListener('pointerdown', event => { backdropDown = outside(event); });
    panel.addEventListener('click', event => { if (backdropDown && outside(event)) closePanel(panel); backdropDown = false; });
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape' && typeof panel.showModal !== 'function') { event.preventDefault(); closePanel(panel); }
    });
    const loading = panel.querySelector('[data-nfc-reviews-loading]');
    const widget = panel.querySelector('.jdgm-review-widget');
    const checkLoaded = () => {
      if (!widget) return;
      const loaded = !!widget.querySelector('.jm-review-widget, .jdgm-rev-widg');
      if (loading) loading.hidden = loaded;
      panel.querySelector('.nfc-reviews-floor')?.setAttribute('aria-busy', String(!loaded));
      if (loaded) clearTimeout(loadingTimer);
    };
    if (widget) new MutationObserver(checkLoaded).observe(widget, { childList: true, subtree: true });
    checkLoaded();
    panel._nfcOpenReviews = button => {
      if (active && active !== panel) closePanel(active);
      opener = button;
      if (panel.open) return;
      scrollState = { html: document.documentElement.style.overflow, body: document.body.style.overflow, padding: document.body.style.paddingRight };
      const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      if (scrollbar) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight || '0') + scrollbar}px`;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      active = panel;
      if (typeof panel.showModal === 'function') panel.showModal();
      else { panel.setAttribute('open', ''); panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); }
      button.setAttribute('aria-expanded', 'true');
      panel.querySelector('[data-nfc-reviews-close]')?.focus({ preventScroll: true });
      checkLoaded();
      if (loading && !loading.hidden) loadingTimer = setTimeout(() => setText(loading, 'Reviews are taking longer to load. Please close this panel and try again.'), 12000);
    };
  }
  function initBadge(badge) {
    if (initialized.has(badge)) return;
    initialized.add(badge);
    const source = badge.querySelector('.nfc-review-badge-source');
    const button = badge.querySelector('[data-nfc-reviews-open]');
    if (!source || !button) return;
    const sync = () => {
      const data = source.querySelector('[data-average-rating][data-number-of-reviews]');
      if (!data) return;
      const count = Number(String(data.getAttribute('data-number-of-reviews')).replace(/,/g, ''));
      const rating = Number(data.getAttribute('data-average-rating'));
      if (!Number.isFinite(count) || count < 0) return;
      const score = badge.querySelector('[data-nfc-rating-score]');
      const stars = badge.querySelector('[data-nfc-rating-stars]');
      const hasRating = count > 0 && Number.isFinite(rating) && rating > 0 && rating <= 5;
      const label = count ? `${count.toLocaleString('en-US')} ${count === 1 ? 'review' : 'reviews'}` : 'Be the first to review';
      if (score) { score.hidden = !hasRating; if (hasRating) setText(score, `${rating.toFixed(1)}/5`); }
      if (stars) { stars.hidden = !hasRating; if (hasRating) stars.style.setProperty('--nfc-rating-fill', `${rating / 5 * 100}%`); }
      setText(badge.querySelector('[data-nfc-rating-count]'), label);
      button.setAttribute('aria-label', hasRating ? `Read ${label}, rated ${rating.toFixed(1)} out of 5` : label);
      const panel = document.getElementById(button.dataset.nfcReviewsOpen);
      const summary = panel?.querySelector('[data-nfc-reviews-summary]');
      if (summary) { summary.hidden = false; setText(summary, hasRating ? `${rating.toFixed(1)}/5 · ${label}` : label); }
    };
    new MutationObserver(sync).observe(source, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews'] });
    sync();
    button.addEventListener('click', event => {
      event.preventDefault();
      const panel = document.getElementById(button.dataset.nfcReviewsOpen);
      if (panel) { initPanel(panel); panel._nfcOpenReviews(button); }
    });
  }
  function init(root = document) {
    root.querySelectorAll('[data-nfc-reviews-panel]').forEach(initPanel);
    root.querySelectorAll('[data-nfc-review-badge]').forEach(initBadge);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
